import {
  type IService,
  type IServicePriceSettings,
  type IServicePriceSettingsParam,
  ServiceFormats,
  ServiceTypes
} from '@types';
import { hmToTMinutes } from '@utils/minutes';
import { differenceInHours } from 'date-fns';

const DEFAULT_BREAK = 0;
export function getServiceBreak(service: IService): number {
  return service.breakIsEnable && +service.break || DEFAULT_BREAK;
}

export function isPriceParamIncludePeriod(param: Pick<IServicePriceSettingsParam, 'timeStart' | 'timeEnd'>, { dateStart, dateEnd }: { dateStart: Date, dateEnd: Date }): boolean {
  const bookingStart = hmToTMinutes(dateStart.getMinutes(), dateStart.getHours());
  const bookingEnd = hmToTMinutes(dateEnd.getMinutes(), dateEnd.getHours());
  if (differenceInHours(dateEnd, dateStart) >= 24) return true;
  const timeStart = +param.timeStart;
  const timeEnd = +param.timeEnd;
  if (bookingEnd < bookingStart) {
    return (bookingStart < timeEnd && timeStart < 1440) || (0 < timeEnd && timeStart < bookingEnd);
  }
  return bookingStart < timeEnd && timeStart < bookingEnd;
}

// TODO почему 2 разные реализации?
export function getServiceMinLength(service: IService): number {
  return +(service?.type === ServiceTypes.Rent ? service?.minTimeLength : service?.timeLength) || 0
}

export function getServiceMinTimeLength(service: IService, priceSettings: IServicePriceSettings[], { dateStart, dateEnd }: { dateStart: Date, dateEnd: Date }) {
  const { minTimeLength, timeLength } = service;

  if (service.type === ServiceTypes.Individual) {
    return +timeLength
  }

  if (service.format !== ServiceFormats.without) {
    const parameters = priceSettings?.reduce<IServicePriceSettingsParam[]>((val, cur) => val.concat(cur.parameters), [])
      .filter((param) => {
        if (!dateStart) return true;
        return isPriceParamIncludePeriod(param, { dateStart, dateEnd });
      })
      .map((param) => hmToTMinutes(+param.durationMinutes, +param.durationHour));

    if (!parameters) return +minTimeLength

    return +Math.max(+minTimeLength, Math.min(...parameters))
  }

  return +minTimeLength;
}
